import { object, string, optional } from "valibot";
import * as v from "valibot";
import { rpcContract } from "../rpc";

export const resendOTPRpcContract = rpcContract({
  name: "resendOTP" as const,
  paramsSchema: object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
    // Optional parameters for email change flow
    userId: optional(string()),
    isEmailChange: optional(v.boolean()),
  }),
  resultSchema: object({}),
});

export type ResendOTPParams = v.InferOutput<typeof resendOTPRpcContract.paramsSchema>;
export type ResendOTPResult = v.InferOutput<typeof resendOTPRpcContract.resultSchema>;
